// This file is part of Indico.
// Copyright (C) 2002 - 2019 CERN
//
// Indico is free software; you can redistribute it and/or
// modify it under the terms of the MIT License; see the
// LICENSE file for more details.
import 'AngularJS/dist/angular';
import 'AngularJS/dist/angular-resource';
import 'AngularJS/dist/angular-sanitize';
import 'AngularJS/css/angular.css';
import 'angular-ui-sortable';

import './app.js';
import './directives';
import './filters';
import './services';
